var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"text-xs-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',[_vm._v("Nosotros")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }